export default {
  // no colors in the TH palette will fulfill a11y contrast requirements
  unselectedColor: '#6B6B6B',
  activeBorderColor: Styles.color.primary,
  activeColor: Styles.color.black,
};
